import { render, staticRenderFns } from "./CaseManagement.vue?vue&type=template&id=f104ec9e"
import script from "./CaseManagement.vue?vue&type=script&lang=js"
export * from "./CaseManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports